<mat-drawer-container id="main_container" autosize>
  <mat-card class="custom-mat-card">
    <mat-card-content class="custom-mat-card-content">
      <div id="container" class="custom-container">
        <div id="header" class="header-title">
          <div id="contentRow" class="custom-header-row">
            <span class="header-title"
              >{{ integrationCategoryList[selectedIndex()].name }} Integrations</span
            >
            <span class="spacer"></span>
            <div id="statusContent" class="status-field"></div>
            <div id="search_div" class="search-field">
              <mat-form-field id="searchField" class="search-input-holder">
                <input
                  id="searchInput"
                  placeholder="Search..."
                  matInput
                  class="search-input"
                  autocomplete="off"
                  name="search-no-autofill"
                  (keyup)="search($event.target.value)" />
              </mat-form-field>
            </div>
            <div id="export_data" class="export-holder center pointer" (click)="exportData()">
              Export
            </div>
            <button
              id="add_ops_api"
              class="add-button"
              mat-button
              [routerLink]="['/integrations', apiUrlPaths[selectedIndex()], action.create]">
              Create<i class="fal fa-plus add-button-icon margin-left-10"></i>
            </button>
          </div>
        </div>
        <mat-tab-group
          mat-stretch-tabs="false"
          mat-align-tabs="start"
          class="custom-mat-tabs"
          [selectedIndex]="selectedIndex()"
          (selectedIndexChange)="onTabChange($event)">
          @for (category of integrationCategoryList; track category.name) {
            <mat-tab [label]="category.name" [disabled]="!category.enabled">
              <ng-template matTabContent>
                <app-operational-api-table
                  [integrationCategory]="category.name"
                  [searchTerm]="searchTerm()" />
              </ng-template>
            </mat-tab>
          }
        </mat-tab-group>
      </div>
    </mat-card-content>
  </mat-card>
</mat-drawer-container>
